import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'parameter',
  templateUrl: './parameter-docs.component.html',
  styleUrls: ['./parameter-docs.component.scss']
})
export class ParameterDocsComponent implements OnInit {

  @Input() parameters: any;
  @Input() title: any;
  @Input() allParamRequired = false;
  @Input() isTypeFormData = false;
  @Input() hasFixedInputType = false;
  @Input() inputType = 'string';
  @Input() apiType: string;
  hasValues = false;

  constructor() { }

  ngOnInit(): void {
    if (this.parameters) {
      this.hasValues = this.parameters.some(obj => obj.key !== '');
      if (this.allParamRequired) {
        for (const val of this.parameters) {
          val['req'] = true;
        }
      }
    }
  }

  hasRequiredParams(): boolean {
    return this.parameters.some(param => param.req === true);
  }

  saveDescription(param: any, value: string) {
    param.description = value;
  }
}
